import React from "react";
import "./Team.css";
import engToNepNumber from "../../../helpers/EngToNepNumber";

function MemberDetail({subHeaderItems}) {
    const languageStatus = sessionStorage.getItem("language");
    return (
        <>
            <div style={{display: 'flex', flexBasis: '33.33%', flexWrap: 'wrap'}} className="uk-margin-large" key={`${subHeaderItems.id}`}>
              {subHeaderItems.subHeaders && subHeaderItems.subHeaders.length > 0
                  ? subHeaderItems.subHeaders.map((data, key) => {
                          return (
                                  <div className="uk-width-1-4@m uk-width-1-2@s" key={key}>
                                      <div
                                          className="uk-panel uk-tile-default uk-padding-large uk-margin-remove-first-child uk-margin"
                                          data-id="page#7-0-1-1"
                                      >
                                          <picture className="aspect-sq">
                                              <img
                                                  decoding="async"
                                                  src={
                                                      data.photoUrl
                                                          ? data.photoUrl
                                                          : "assets/images/image.png"
                                                  }
                                                  alt=""
                                                  loading="lazy"
                                              />
                                          </picture>
                                          <h3 className="el-title uk-card-title uk-margin-small-top uk-margin-remove-bottom">
                                                  <>
                                                      <span>{languageStatus === 'en' ? data.name : data.nameNp }</span>
                                                  </>
                                          </h3>
                                          <div className="el-meta uk-text-meta">
                                                  <>
                                                      <span>{languageStatus === 'en' ? data.staffDesignation : (data.staffDesignationNp !== '' ? data.staffDesignationNp : data.staffDesignation)}</span>
                                                  </>
                                              <br />
                                              {data.staffContactNumber1 ? (
                                                  <>
                                                      <span>{languageStatus === 'en' ? data.staffContactNumber1 : engToNepNumber(data.staffContactNumber1)}</span>
                                                  </>
                                              ) : null}
                                          </div>
                                      </div>
                                  </div>
                          )
                      }
                  ) : null
              }
              </div>
          {/*</>*/}
      </>
    );
}

export default MemberDetail;
